import React from 'react';

import { Gap, Icon, Text } from '@common/components';
import { MessengerLauncherWrapper } from 'works/components/messenger-launcher-wrapper';
import { Colors } from 'works/legacy/lib/style-helper';

export const AuthTemplateHelp = () => (
  <>
    <div className="help-container">
      <Gap>
        <div className="help-text">Need some help?</div>
        <div className="intercom">
          <MessengerLauncherWrapper>
            <Gap align="center">
              <Text color="elm" bold>
                Chat with Support
              </Text>
              <Icon
                className="intercom-icon"
                icon="commentAltSmile"
                kind="regular"
              />
            </Gap>
          </MessengerLauncherWrapper>
        </div>
      </Gap>
    </div>

    <style jsx>
      {`
        .SupplierSignUpPage :global(.intercom) {
          margin-left: 8px;
          display: flex;
        }

        .help-container :global(.intercom-icon) {
          margin-left: 5px;
        }

        .help-container :global(.help-container) {
          display: flex;
          vertical-align: bottom;
        }

        .help-container :global(.intercom:hover) {
          text-decoration: underline;
        }

        .help-container :global(.help-text) {
          color: ${Colors.midnightLighter};
        }

        .help-container :global(.help-text) {
          color: ${Colors.midnightLighter};
        }

        .help-container :global(.active-accounts) {
          box-shadow: 0 4px 12px 0 #2423291f;
          margin-bottom: 18px;
        }
      `}
    </style>
  </>
);
